import { useCallback, useContext } from 'react'
import type { Filter_1_0_0 } from '@luxuryescapes/contract-data-event-schemas/lib/com.luxgroup'

import { trackEvent } from 'analytics/analytics'
import { mapGlobalSearchContextToSnowplowSearchEvent } from 'analytics/mapSnowplowSearchTracking'
import { searchEventWithContext } from 'analytics/snowplow/events'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'

export type ExperienceSearchFilterContext = Filter_1_0_0

export default function useTrackExperienceSearchFilter() {
  const globalSearchState = useContext(GlobalSearchStateContext)
  return useCallback((filterContexts: ExperienceSearchFilterContext | Array<ExperienceSearchFilterContext>) => {
    const contexts = Array.isArray(filterContexts) ? filterContexts : [filterContexts]
    if (contexts.length === 0) return

    trackEvent(searchEventWithContext({
      searchEvent: { type: 'filters' },
      sortContext: { value: 'recommended' },
      searchContext: mapGlobalSearchContextToSnowplowSearchEvent({
        ...globalSearchState,
        searchVerticals: new Set(['experiences']),
      }),
      filterContexts: contexts,
    }))
  }, [globalSearchState])
}
